import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AlertBox from './AlertBox'
import $ from 'jquery';
import InputGroup from 'react-bootstrap/InputGroup';

var demoDone = false;
function Demo(prop) {
    //mani
    var mode = 0;
    useEffect(function (a) {
        $('.top_switch').remove();
        localStorage.clear();
        var pp = window.getPageParams();
        // delete window.GlobalVars.postLogin;
        // alert( pp.next )
        if (pp.next) {
            try {
                var pl = atob(pp.next);
                window.GlobalVars.postLogin = pl; 
            }
            catch (e) { console.error(e) }
            return window.saveSession( () => {
                document.location = '/?next=#Login';
            });
        }
        // if( document.location.href.indexOf('?next=#Login') == -1 ) {
        //     return document.location = '/?next=#Login';
        // }
        
    })
    function submit(e)
    {
        e.preventDefault();
        if( demoDone ) return;
        window.endSession();
        window.alertOut();
        var email = $('#email').val().trim();
        var firstname = $('#firstname').val().trim();
        var lastname = $('#lastname').val().trim();
        var company = $('#company').val().trim();
        var phone = $('#phone').val().trim();
        if( firstname == '' )
        {
            $('#firstname').focus();
            return window.alertBox( 'Please Enter your First Name', 'err' );
        }
        if( lastname == '' )
        {
            $('#lastname').focus();
            return window.alertBox( 'Please Enter your Last Name', 'err' );
        }
        if( company == '' )
        {
            $('#company').focus();
            return window.alertBox( 'Please Enter your Company Name', 'err' );
        }
        if( email == '' )
        {
            $('#email').focus();
            return window.alertBox( 'Please Enter your Email Address', 'err' );
        }
        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email = $("#email").val();
      if (email.includes("@gmail.com") || email.includes("@yahoo.com") || email.includes("@outlook.com")) {
        // return window.alertBox('Please enter a valid business email address')
        return;
      }
            return re.test(String(email).toLowerCase());
        }
        if( !validateEmail(email) ) return window.alertBox( 'Please use a valid  business Email address', 'err' );
        window.post( 'register_demo', {fname:firstname,lname:lastname,company:company,userInfo:{company:company},email:email,phone:phone}, function(res){
            var data = res.data;
            console.log( 'DEMO', data )
            if( data.status )
            {
                window.alertOut();
                window.endSession();
                window.GlobalVars.user = email;
                window.GlobalVars.userName = firstname + ' ' + lastname +' (guest)';
                var priv = {user:1};
                window.GlobalVars.userPriv = priv;
                window.GlobalVars.sessionId = Math.random();
                window.GlobalVars.expireTime = Date.now()+1000*60*window.sessionDuration;
                window.saveSession();

                window.alertBox('An email was sent to <b>'+email+'</b>. Please check your access information and log in to ADL.', 'ok');
                $('input').hide();
                $('#subtxt').hide();
                $('#button').html('Login').on('click',function(){
                    window.goPage('');
                })
                demoDone = true;
                setTimeout( function(){
                    // window.goPage('');
                }, 10000 );
            }
            else {
                window.alertBox('You are already registered in ADL', 'err');
            }
        });

    }

    return (
        <div className="login_wrapper">
        <Container fluid="md" className="mp0">
        <Row>
        <Col sm={3}></Col>
        <Col sm={6}>
        <img className="login-logo" src="imgs/objectways-logo.png"/>
        <div className="login">
        <Form method="GET"  onSubmit={submit}>
            {/* <Form.Label><h3>Datalake Demo Version</h3> */}
            <Form.Label><h3>Sign Up</h3>
            {/* <span id="subtxt">Enter the details below to access the Demo</span> */}
            </Form.Label>
            <AlertBox/>
            <Row>
                <Col className="mr-0 pr-0">
                <Form.Control placeholder="First name *" id="firstname" className="err"/>
                </Col>
                <Col className="ml-0 pl-2">
                <Form.Control placeholder="Last name *"  id="lastname"/>
                </Col>
            </Row>

            {/* <FormControl type="text" id="firstname" placeholder="First Name " className="mt-2 mb-2"/> */}

            {/* <InputGroup className="mb-3">
         <span class="input-group-text" id="inputGroupPrepend">@</span>
        <Form.Control
          placeholder="Username"
          aria-label="Username"
          aria-describedby="basic-addon1"
        />
      </InputGroup> */}

            {/* <FormControl  type="text" id="firstname" placeholder="First Name " className="mt-2 mb-2"/> */}



            {/* <FormControl type="text" id="lastname" placeholder="Last Name "  className="mt-2 mb-2"/> */}

            <FormControl  type="text" id="company" placeholder="Company Name * " className=" mb-2"/>
            <FormControl  type="e-mail" className="mb-2" id="email" placeholder="yourmail@company.com * "/>
            <FormControl type="tel" className="mb-2" id="phone" placeholder="Phone Number "/>
            <Button variant="primary" id="button" type="submit" className="mt-2">Sign Up</Button>

        </Form>
        </div>
        </Col>
        <Col sm={3}></Col>
        </Row>
        </Container>
        </div>
    )

}

export default Demo
